import React, { useContext, useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
    Text,
    Icon,
    Conditional,
    Loader,
    Modal,
    ModalContent,
    ModalHeader,
    Cross,
    AlertModal
} from '@cashfree-intl/coherent';
import Forms from 'containers/LandingPage/components/HelpCenterForm';
import { OPEN_HC_FORM_FROM_URL } from 'containers/LandingPage/constants';
import { HELP_CENTER_URL, SUCCESS } from 'utils/constants';
import { MerchantDetailsContext } from 'contexts/MerchantDetailsContext';

const RaiseIssue = ({
    showError,
    closeHcForm,
    generateHcForm,
    landingData: {
        isLoading,
        helpCenter: { isFormOpened },
    },
}: any) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [showAlert, setShowAlert] = useState(false);
    const { merchantDetails } = useContext(MerchantDetailsContext);


    const handleHcOpen = () => {
        generateHcForm({
            merchantId: merchantDetails?.id,
            email: merchantDetails?.merchantEmail,
        });
    };


    useEffect(() => {
        if (
            searchParams.get(OPEN_HC_FORM_FROM_URL.param) ===
            OPEN_HC_FORM_FROM_URL.value
        ) {
            setTimeout(() => {
                handleHcOpen();
            }, 1000);
        }
    }, []);

    const handleCloseHcForm = () => {
        closeHcForm();
        deleteOpenSearchParam();
    }


    const deleteOpenSearchParam = () =>
        setSearchParams((params) => {
            params.delete(OPEN_HC_FORM_FROM_URL.param);
            return params;
    });


    const handleSubmit = (data: any) => {
        if (data) {
            if (data?.meta?.status === SUCCESS) {
                setShowAlert(true);
                handleCloseHcForm();
            } else if (data?.response?.status !== 200) {
                const err = new Error(data?.response?.data?.detail);
                showError(err);
            } else {
                const err = new Error(
                    'Unable to create a ticket. Please retry after some time'
                );
                showError(err);
            }
        }
    };

    return (
        <>
            <Conditional if={isLoading}>
                <Loader active />
            </Conditional>
            <Conditional if={!isLoading}>
                <Modal
                    open={isFormOpened}
                    className="help-center-modal"
                    onClose={handleCloseHcForm}
                >
                    <ModalHeader>
                        Raise an issue
                        <Cross onClick={handleCloseHcForm} />
                    </ModalHeader>
                    <ModalContent className="help-center-modal-content">
                        {/* @ts-ignore */}
                        <Forms handleSubmit={handleSubmit} />
                    </ModalContent>
                </Modal>
            </Conditional>
            <Conditional if={showAlert}>
                <AlertModal
                    type="success"
                    title="Your ticket has been created successfully."
                    onClose={() => {
                        setShowAlert(false);
                        deleteOpenSearchParam();
                    }}
                >
                    <a
                        className="cashfreeCareLink"
                        href={HELP_CENTER_URL}
                        target="__blank"
                    >
                        <Text>
                            View ticket <Icon name="navigate-to" />
                        </Text>
                    </a>
                </AlertModal>
            </Conditional>
        </>
    );
};


export default RaiseIssue